/* eslint-disable react/react-in-jsx-scope */
// import { Link, useNavigate, redirect } from "react-router"
// import { useAuth } from "./AuthProvider";
import { useUserContext } from '../contexts/UserContext';
import BarChartBox from "./barChartBox/BarChartBox";
import BigChartBox from "./bigChartBox/BigChartBox";
import ChartBox from "./chartBox/ChartBox";
import PieChartBox from "./pieCartBox/PieChartBox";
import TopBox from "./topBox/TopBox";
import {
  barChartBoxRevenue,
  barChartBoxVisit,
  chartBoxConversion,
  chartBoxProduct,
  chartBoxRevenue,
  chartBoxUser,
} from "../data";
import "./home.css";

const Dashboard = () => {
  // const auth = useAuth();
  const user = useUserContext();

  return (
    <div className="flex p-4 overflow-y-auto justify-between  h-[calc(100vh-120px)]">
      <div className="w-full  h-[calc(100vh-120px)]">
        <h1>Welcome! {user.user?.name}</h1>
        <div className="home">
          <div className="box box1">
            <TopBox />
          </div>
          <div className="box box2 grid-flow-col">
            <ChartBox {...chartBoxUser} />
          </div>
          <div className="box box3">
            <ChartBox {...chartBoxProduct} />
          </div>
          <div className="box box4">
            <PieChartBox />
          </div>
          <div className="box box5">
            <ChartBox {...chartBoxConversion} />
          </div>
          <div className="box box6">
            <ChartBox {...chartBoxRevenue} />
          </div>
          <div className="box box7">
            <BigChartBox />
          </div>
          <div className="box box8">
            <BarChartBox {...barChartBoxVisit} />
          </div>
          <div className="box box9">
            <BarChartBox {...barChartBoxRevenue} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;